import React, { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCustomerNote } from '../../../store/checkoutSlice';
import './customerNoteForm.css';

const CustomerNoteForm = ({ setIsValid }) => {
  const dispatch = useDispatch();
  const savedNote = useSelector((state) => state.checkout.customerNote || '');

  const [note, setNote] = useState(savedNote);
  const [isSaved, setIsSaved] = useState(Boolean(savedNote));
  const [isEditing, setIsEditing] = useState(!savedNote);
  const [noteSkipped, setNoteSkipped] = useState(false);

  const toastRef = useRef(null);
  const textareaRef = useRef(null);

  // Debug state
  useEffect(() => {
    console.log('State ->', { isEditing, isSaved, noteSkipped, note });
  }, [isEditing, isSaved, noteSkipped, note]);

  // Parent validity
  useEffect(() => {
    setIsValid(isSaved || noteSkipped);
  }, [isSaved, noteSkipped, setIsValid]);

  // Focus textarea
  useEffect(() => {
    if (isEditing && textareaRef.current) textareaRef.current.focus();
  }, [isEditing]);

  const handleNoteChange = (e) => setNote(e.target.value);

  const showToast = (message, type = 'success') => {
    const el = toastRef.current;
    if (!el) return;
    el.querySelector('.toast-body').textContent = message;
    el.classList.remove('bg-success', 'bg-warning');
    el.classList.add(type === 'success' ? 'bg-success' : 'bg-warning');
    new window.bootstrap.Toast(el, { delay: 3000, autohide: true }).show();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = note.trim();
    if (!trimmed) {
      dispatch(setCustomerNote(''));
      setIsSaved(false);
      setIsEditing(true);
      setNoteSkipped(false);
      showToast('Nota eliminada.', 'warning');
    } else {
      dispatch(setCustomerNote(trimmed));
      setIsSaved(true);
      setIsEditing(false);
      setNoteSkipped(false);
      showToast('Nota guardada con éxito.', 'success');
    }
  };

  const handleEdit = (e) => {
    e.preventDefault();
    console.log('Edit clicked');
    setIsEditing(true);
    setIsSaved(false);
    setNoteSkipped(false);
  };

  const handleSkipNote = (e) => {
    e.preventDefault();
    setNote('');
    dispatch(setCustomerNote(''));
    setIsSaved(false);
    setIsEditing(false);
    setNoteSkipped(true);
    showToast('No se agregará ninguna nota.', 'success');
  };

  const handleLeaveNote = (e) => {
    e.preventDefault();
    setIsEditing(true);
    setNoteSkipped(false);
  };

  return (
    <>
      <div className="container mt-4">
        <div className="card shadow-sm note-form-card">
          <div className="card-header bg-secondary text-white">
            <h5 className="mb-0">Nota del Cliente</h5>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <textarea
                  ref={textareaRef}
                  className="form-control"
                  rows="4"
                  placeholder="“Escribe aquí indicaciones especiales para la entrega, como dejar el paquete en portería, llamar al llegar, horario preferido o cualquier detalle importante que facilite la recepción.”"
                  value={note}
                  onChange={handleNoteChange}
                  disabled={!isEditing}
                />
              </div>
              <div className="d-flex justify-content-between">
                {noteSkipped ? (
                  <button type="button" className="btn btn-primary" onClick={handleLeaveNote}>
                    Dejar Nota
                  </button>
                ) : (
                  <button type="button" className="btn btn-outline-secondary" onClick={handleSkipNote}>
                    No dejar nota
                  </button>
                )}
                <div>
                  {isEditing ? (
                    <button type="submit" className="btn btn-success" disabled={!note.trim()}>
                      Guardar Nota
                    </button>
                  ) : (
                    isSaved && (
                      <button type="button" className="btn btn-warning" onClick={handleEdit}>
                        Editar Nota
                      </button>
                    )
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        ref={toastRef}
        className="toast align-items-center text-white position-fixed bottom-0 end-0 m-4"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div className="d-flex">
          <div className="toast-body">Mensaje</div>
          <button type="button" className="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
      </div>
    </>
  );
};

export default CustomerNoteForm;
